import { ArrowRight, Filter, Search, Calendar, List, Grid } from "react-feather";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../incomeGrid.module.css";

const GridFilters = ({ setPage, setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, handleView }) => {
  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => {
          setFilterData((prev) => {
            return { ...prev, searchKey: e.target.value };
          });
          setPage(0);
        }} />
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });
                selectProperty(e.target.value);
              }}
            >
              {propertyList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Apartment</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Apartment"
              value={filterData?.apartment}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, apartment: e.target.value };
                });
              }}
            >
              {apartmentList.length === 0 && (<MenuItem disabled value={""}>Select Property First</MenuItem>)}
              {apartmentList?.map((i) => {
                return (<MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>);
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Payment Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Payment Status"
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, payment_status: e.target.value };
                });
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value={0}>Outstanding</MenuItem>
              <MenuItem value={1}>Balance</MenuItem>
              <MenuItem value={2}>Over Paid</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, last_payment_date: date };
                });
              }}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} `} onClick={() => handleView("list")}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
}

export default GridFilters;